import { Box, styled, Button as MuiButton, Modal } from "@mui/material";

export const primaryBlue = `#003893`;

export const Block = styled(Box)<{ size?: string }>(({ size }) => ({
    display: size && size === `large` ? `inline-block` : `block`,
    width: size && size === `large` ? `calc(100% - 335px)` : `100%`,
}));

export const Button = styled(MuiButton)(() => ({
    padding: `4px 8px`,

    borderRadius: `10px`,
    backgroundColor: `#fff`,
    color: primaryBlue,
    border: `1px solid ${primaryBlue}`,
    cursor: `pointer`,
    fontSize: `18px`,
    margin: `20px auto 0`,
    display: `block`,

    a: {
        color: `inherit`,
        textDecoration: `none`,

        "&:visited": {
            color: `#d81e05`,
        },
    },
    "&.small": {
        margin: 0,
        padding: `4px 8px`,
        borderColor: `#c8c8c8`,
        boxShadow: `none`,
        color: `#000`,
        fontSize: `14px`,

        a: {
            color: `#000`,
        },
    },

    "&.small.primary": {
        borderColor: `#d81e05`,
        background: `#fff`,
    },

    "&:disabled": {
        color: `#ccc`,
    },
}));

export const AccountModal = styled(Modal)<{ size?: string }>(({ size, sx = {} }) => ({
    width: `100%`,
    height: `100%`,
    position: `fixed`,
    zIndex: 999,
    "& .modalContent": {
        maxWidth: `800px`,
        outline: `none`,
        minWidth: size === `small` ? `unset` : `500px`,
        position: `fixed`,
        marginTop: 0,
        top: `50%`,
        left: `50%`,
        transform: `translate(-50%,-50%)`,
        zIndex: 333,
        height: size === `small` ? `100%` : `auto`,
        width: size === `small` ? `100%` : `auto`,
        ...(sx as Record<string, string>),
    },
}));
